import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { HeavyVehicles } from "@/components/site/HeavyVehicles";
import { Differentials } from "@/components/site/Differentials";
import { Urgency } from "@/components/site/Urgency";
import { Gallery } from "@/components/site/Gallery";
import { VideoShowcase } from "@/components/site/VideoShowcase";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Testimonials } from "@/components/site/Testimonials";
import { Social } from "@/components/site/Social";
import { Footer } from "@/components/site/Footer";
import { FloatingCTA } from "@/components/site/FloatingCTA";

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a0a]">
      {/* Font Awesome for WhatsApp icon */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
      />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <HeavyVehicles />
        <Differentials />
        <Urgency />
        <VideoShowcase />
        <Gallery />
        <ServiceArea />
        <Testimonials />
        <Social />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default App;
